import { useFetchViewById } from './useFetchViewById';
import { useActiveViewId } from './viewTabs';
export function useActiveView({
  skipQuery = false
} = {}) {
  const viewId = useActiveViewId();
  return useFetchViewById({
    skipQuery,
    viewId
  });
}